import {
  DEFAULT_SHOW_BUTTON_SUBMIT,
  DISABLED_BUTTON_SUBMIT,
  instance1,
  TYPE_INSTANCE1,
} from "App/constants";
import { InputTextMaster, MasterButton, Modal } from "App/Component/ui";
import { Grid } from "@material-ui/core";
import { useState } from "react";
import {
  defaultToastError,
  defaultToastSuccess,
  fetchData,
  titleModal,
} from "App/utils/helpers";
import { LIST_URL_MASTER } from "utils/masters";

export const getAllQualification = async () => {
  try {
    const api = await instance1.get(LIST_URL_MASTER.kualifikasi.list);
    const res = api.data;
    return res.body;
  } catch (error) {
    defaultToastError(error?.response?.data?.message);
    return false;
  }
};

export const deleteQualificationById = async (
  id,
  setRows,
  setShowModalDeleteConfirm,
  setFormData
) => {
  try {
    await instance1.post(
      LIST_URL_MASTER.kualifikasi.delete,
      {},
      {
        headers: {
          idqualification: id,
        },
      }
    );
    const newData = await fetchData(
      TYPE_INSTANCE1,
      LIST_URL_MASTER.kualifikasi.list
    );
    setRows(newData);
    setShowModalDeleteConfirm(false);
    setFormData({
      id: "",
      name: "",
      code: "",
    });
    return defaultToastSuccess("Data berhasil dihapus");
  } catch (error) {
    return defaultToastError(error?.response?.data?.message);
  }
};

export const headCells = [
  {
    id: "no",
    disablePadding: false,
    label: "NO",
    align: "center",
    sort: false,
  },
  {
    id: "act",
    disablePadding: true,
    label: "ACT",
    sort: false,
    align: "center",
  },
  {
    id: "name",
    disablePadding: false,
    label: "NAMA",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "remark",
    disablePadding: false,
    label: "REMARK",
    align: "left",
    minWidth: "150px",
  },
  {
    id: "inserted_time",
    disablePadding: false,
    label: "INSERTED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "inserted_by",
    disablePadding: false,
    label: "INSERTED BY",
    sort: false,
    minWidth: "150px",
  },
  {
    id: "updated_time",
    disablePadding: false,
    label: "UPDATED TIME",
    sort: false,
    minWidth: "170px",
  },
  {
    id: "updated_by",
    disablePadding: false,
    label: "UPDATED BY",
    sort: false,
    minWidth: "150px",
  },
];

export const ModalForm = ({ setShowModal, data, setRows }) => {
  const [disabled, setDisabled] = useState(DEFAULT_SHOW_BUTTON_SUBMIT);

  const [formData, setFormData] = useState({
    name: data.name,
    remark: data.remark,
    id: data.id,
  });

  const addQualification = async () => {
    return instance1.post(LIST_URL_MASTER.kualifikasi.add, {
      ...formData,
    });
  };

  const updateQualification = () => {
    return instance1.post(
      LIST_URL_MASTER.kualifikasi.update,
      {
        ...formData,
      },
      {
        headers: {
          idqualification: formData.id,
        },
      }
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setDisabled(DISABLED_BUTTON_SUBMIT);

    if (formData.name === "") {
      setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
      defaultToastError("Nama tidak boleh kosong");
    } else {
      try {
        if (formData.id === "") {
          await addQualification();
        } else if (formData.id !== "") {
          await updateQualification();
        }
        const newData = await fetchData(
          TYPE_INSTANCE1,
          LIST_URL_MASTER.kualifikasi.list
        );
        setRows(newData);
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);

        setShowModal(false);
      } catch (error) {
        setDisabled(DEFAULT_SHOW_BUTTON_SUBMIT);
        defaultToastError(error?.response?.data?.message);
      }
    }
  };

  const handleChange = (text) => (e) => {
    setFormData({
      ...formData,
      [text]: e.target.value,
    });
  };

  return (
    <Modal
      title={`${titleModal(formData.id)} Kualifikasi Pendidikan`}
      show={setShowModal}>
      <form action='POST' onSubmit={(e) => handleSubmit(e)}>
        <Grid container spacing={1}>
          <InputTextMaster
            type='hidden'
            name='id'
            id='id'
            readOnly={true}
            value={formData.id}
          />
          <Grid item sm={12}>
            <InputTextMaster
              name='name'
              label='Nama'
              id='name'
              value={formData.name}
              onChange={handleChange("name")}
              placeholder='Nama'
            />
          </Grid>

          <Grid item sm={12}>
            <InputTextMaster
              name='remark'
              label='Remark'
              id='remark'
              value={formData.remark}
              onChange={handleChange("remark")}
              placeholder='Remark'
            />
          </Grid>
        </Grid>
        <Grid
          container
          direction='row'
          justifyContent='flex-end'
          alignItems='center'>
          <MasterButton
            className={"mt-1"}
            type='submit'
            color={disabled.color}
            name={disabled.label}
            size='md'
          />
        </Grid>
      </form>
    </Modal>
  );
};
